var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry, actionExecutionLocations) {
  pluginRegistry.registerDeploymentAction("Octopus.HealthCheck", function() {
    return {
      executionLocation: actionExecutionLocations.alwaysOnServer,
      canChooseRoles: true,
      canHaveChildren: function() { return false; },
      canBeChild: false,
      hasPackages: function(action) { return false; },

            summaryTemplateUrl: "areas/projects/actions/Octopus.HealthCheck_summary.html",
            editTemplateUrl: "areas/projects/actions/Octopus.HealthCheck_edit.html",
            editLink: function ($scope, element) {
                if (!$scope.action.Properties["Octopus.Action.HealthCheck.Type"]) {
                    $scope.action.Properties["Octopus.Action.HealthCheck.Type"] = "FullHealthCheck";
                }
                if (!$scope.action.Properties["Octopus.Action.HealthCheck.ErrorHandling"]) {
                    $scope.action.Properties["Octopus.Action.HealthCheck.ErrorHandling"] = "TreatExceptionsAsErrors";
                }
                if (!$scope.action.Properties["Octopus.Action.HealthCheck.IncludeMachinesInDeployment"]) {
                    $scope.action.Properties["Octopus.Action.HealthCheck.IncludeMachinesInDeployment"] = "DoNotAlterMachines";
                }

            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/Octopus.HealthCheck.js
// module id = 479
// module chunks = 1